function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.1722 21.3811L21.3811 21.3811V22.1721L22.1722 22.1721V21.3811Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1722 2.791C22.1722 2.57256 21.9951 2.39547 21.7767 2.39547V2.39547C21.5582 2.39547 21.3811 2.57256 21.3811 2.791L21.3811 21.3811L22.1722 21.3811L22.1722 2.791Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7623 22.1721C40.9807 22.1721 41.1578 21.9951 41.1578 21.7766V21.7766C41.1578 21.5582 40.9807 21.3811 40.7623 21.3811L22.1722 21.3811V22.1721L40.7623 22.1721Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.79107 21.3811C2.57262 21.3811 2.39553 21.5582 2.39553 21.7766V21.7766C2.39553 21.9951 2.57262 22.1721 2.79107 22.1721L21.3811 22.1721V21.3811L2.79107 21.3811Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.3811 40.7622C21.3811 40.9807 21.5582 41.1578 21.7767 41.1578V41.1578C21.9951 41.1578 22.1722 40.9807 22.1722 40.7622L22.1722 22.1721L21.3811 22.1721V40.7622Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1722 21.3811L21.3811 21.3811M22.1722 21.3811V22.1721M22.1722 21.3811L22.1722 2.791C22.1722 2.57256 21.9951 2.39547 21.7767 2.39547V2.39547C21.5582 2.39547 21.3811 2.57256 21.3811 2.791L21.3811 21.3811M22.1722 21.3811L40.7623 21.3811C40.9807 21.3811 41.1578 21.5582 41.1578 21.7766V21.7766C41.1578 21.9951 40.9807 22.1721 40.7623 22.1721L22.1722 22.1721M21.3811 21.3811V22.1721M21.3811 21.3811L2.79107 21.3811C2.57262 21.3811 2.39553 21.5582 2.39553 21.7766V21.7766C2.39553 21.9951 2.57262 22.1721 2.79107 22.1721L21.3811 22.1721M21.3811 22.1721L22.1722 22.1721M21.3811 22.1721V40.7622C21.3811 40.9807 21.5582 41.1578 21.7767 41.1578V41.1578C21.9951 41.1578 22.1722 40.9807 22.1722 40.7622L22.1722 22.1721",
  stroke: "white",
  strokeWidth: 3.16701
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 43,
  height: 43,
  fill: "white"
})));

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.d4e53b6f.svg";
export { ForwardRef as ReactComponent };